import { CircleCheckIcon, CircleXIcon, CopyIcon } from "lucide-react";

export const copyButtonStates = {
  default: { icon: CopyIcon, message: 'Copiar' },
  success: { icon: CircleCheckIcon, message: 'Copiado' },
  failed: { icon: CircleXIcon, message: 'Erro ao copiar' },
};
